export enum DaysOfWeek {
    Monday = "M",
    Tuesday = "T",
    Wednesday = "W",
    Thursday = "H",
    Friday = "F",
    Saturday = "S",
    Sunday = "U",
}

export type TutorProfileSchema = {
    Name: string,
    Atar: number,
    CompletedSessions: number,
    TutorTier: string,
    Rating: number,
    SchoolId: string,
    Schedule: TutorSchedule,
    Subjects: TutorSubject[],
    Verified: boolean,
};

export type TutorSubject = {
    SubjectID: string,
    Mark: number,
}

export type TutorSchedule = {
    Monday: number,
    Tuesday: number,
    Wednesday: number,
    Thursday: number,
    Friday: number,
    Saturday: number,
    Sunday: number,
    TimeZone: string,
};

export const MaxNumber = 281474976710655;

const nameofTutorProfileSchemaName = "Name";
const nameofTutorProfileSchemaAtar = "Atar";
const nameofTutorProfileCompletedSessions = "CompletedSessions";
const nameofTutorProfileSchemaTutorTier = "TutorTier";
const nameofTutorProfileSchemaRating = "Rating";
const nameofTutorProfileSchemaSchoolId = "SchoolId";
const nameofTutorProfileSchemaTutorSchedule = "Schedule";
const nameofTutorProfileSchemaSubjects = "Subjects";
const nameofTutorProfileSchemaVerified = "Verified";
const nameofTutorProfileSchemaCollection = "TutorProfile";

const nameofTutorSubjectSchemaSubjectID = "SubjectID";
const nameofTutorSubjectSchemaMark = "Mark";

const nameofTutorScheduleMonday = "Monday";
const nameofTutorScheduleTuesday = "Tuesday";
const nameofTutorScheduleWednesday = "Wednesday";
const nameofTutorScheduleThursday = "Thursday";
const nameofTutorScheduleFriday = "Friday";
const nameofTutorScheduleSaturday = "Saturday";
const nameofTutorScheduleSunday = "Sunday";
const nameofTutorScheduleTimeZone = "TimeZone";

export {
    nameofTutorProfileSchemaName,
    nameofTutorProfileSchemaAtar,
    nameofTutorProfileCompletedSessions,
    nameofTutorProfileSchemaTutorTier,
    nameofTutorProfileSchemaRating,
    nameofTutorProfileSchemaSchoolId,
    nameofTutorProfileSchemaTutorSchedule,
    nameofTutorProfileSchemaSubjects,
    nameofTutorProfileSchemaVerified,
    nameofTutorProfileSchemaCollection,
    nameofTutorSubjectSchemaSubjectID,
    nameofTutorSubjectSchemaMark,
    nameofTutorScheduleMonday,
    nameofTutorScheduleTuesday,
    nameofTutorScheduleWednesday,
    nameofTutorScheduleThursday,
    nameofTutorScheduleFriday,
    nameofTutorScheduleSaturday,
    nameofTutorScheduleSunday,
    nameofTutorScheduleTimeZone,
};

export type TutorScheduleNoTimeZone = {
    Monday: number,
    Tuesday: number,
    Wednesday: number,
    Thursday: number,
    Friday: number,
    Saturday: number,
    Sunday: number,
}

export type TutorProfileView = TutorProfileSchema & {
    Id: string,
};

export function getDaysFromString(availability: string): DaysOfWeek[] {
    const days: DaysOfWeek[] = [];
    if (availability.includes(DaysOfWeek.Monday)) {
        days.push(DaysOfWeek.Monday);
    }
    if (availability.includes(DaysOfWeek.Tuesday)) {
        days.push(DaysOfWeek.Tuesday);
    }
    if (availability.includes(DaysOfWeek.Wednesday)) {
        days.push(DaysOfWeek.Wednesday);
    }
    if (availability.includes(DaysOfWeek.Thursday)) {
        days.push(DaysOfWeek.Thursday);
    }
    if (availability.includes(DaysOfWeek.Friday)) {
        days.push(DaysOfWeek.Friday);
    }
    if (availability.includes(DaysOfWeek.Saturday)) {
        days.push(DaysOfWeek.Saturday);
    }
    if (availability.includes(DaysOfWeek.Sunday)) {
        days.push(DaysOfWeek.Sunday);
    }
    return days;
}